module.exports = __webpack_public_path__ + "img/HFIG-600-frequencydomain.03f51a8d.png";